export enum DateFormatsEnum {
  NORMAL = 'DD.MM.YYYY',
  REVERSE = 'YYYY.MM.DD',
}
